import * as yup from 'yup'

const numField = yup
    .number()
    .transform((value, originalValue) =>
        originalValue === '' ? undefined : value
    )
    .nullable()
    .min(0)

export const alertSchema = yup.object({
    thresholds: yup
        .array()
        .of(
            yup
                .object({
                    enabled: yup.boolean().required(),
                    threshold_type: yup.string().when('enabled', {
                        is: true,
                        then: (schema) =>
                            schema.oneOf(['absolute', 'percentage']).required(),
                        otherwise: (schema) => schema.notRequired(),
                    }),

                    warning_threshold: numField.notRequired(),
                    critical_threshold: numField.notRequired(),
                })
                .test(
                    'at-least-one-threshold',
                    'Khi bật cảnh báo, cần nhập ít nhất 1 trong 2: warning_threshold hoặc critical_threshold',
                    (obj) => {
                        if (!obj?.enabled) return true // nếu không bật thì bỏ qua
                        const hasWarn = obj.warning_threshold != null
                        const hasCrit = obj.critical_threshold != null
                        return hasWarn || hasCrit
                    }
                )
        )
        .required(),
})
